import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import classnames from 'classnames';

import { Image } from 'components/ui';
import { getDocumentToReactComponentsOptions } from 'helpers/LandingPageHelpers';

import type { IContentfulImage, IContentfulRichText, Nullable } from 'types';

import styles from './BetaTemplateDefaultBlock.module.scss';

interface Props {
  title: Nullable<IContentfulRichText>,
  description: Nullable<IContentfulRichText>,
  size: 'large' | 'default',
  image: IContentfulImage,
  isMobilePreview: boolean
}

const BetaTemplateDefaultBlock = (props: Props) => {
  const {
    title,
    description,
    size = 'default',
    image,
    isMobilePreview,
  } = props;

  const { json: titleJson } = title || {};
  const { json: descriptionJson } = description || {};
  const { url: imageSrc } = image || {};

  const options = React.useMemo(() => getDocumentToReactComponentsOptions({ isMobilePreview }), [isMobilePreview]);

  return (
    <div className={classnames(styles.root, styles[size])}>
      <div className={styles.inner}>
        <div className={styles.content}>
          {title && <div className={styles.title}>{documentToReactComponents(titleJson, options)}</div>}
          {description && <div className={styles.description}>{documentToReactComponents(descriptionJson, options)}</div>}
        </div>
        <div className={styles.imageContainer}>
          <Image
            className={styles.image}
            src={imageSrc}
            width={400}
            height={400}
            quality={100}
            optimize
          />
        </div>
      </div>
    </div>
  );
};

export default BetaTemplateDefaultBlock;
